/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React from 'react';
import { Typography, Grid, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MenuIcon from '@mui/icons-material/Menu';
import { Drawer, IconButton, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTheme } from '@emotion/react';

const styles = makeStyles((theme) => ({

    barMenuItem: {
        padding: '20px!important',
        "&:hover": {
            background: theme.palette.primary.main
        }
    },
    barMenuItemTypo: {
        paddingLeft: '5px!important',
        "&:hover": {
            color: 'white!important'
        }
    },
}));
const drawerWidth = 200;

const DrawerHeader = styled('div')(({ theme }) => ({
    width: "fit-content",
    display: "inline-block",
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
}));

const SideBar = () => {
    const classes = styles()
    const [open, setOpen] = React.useState(false);
    const theme = useTheme()
    const navigate = useNavigate()
    const handleDrawerClose = () => {
        setOpen(false);
    };
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    return (
        <>
            <Paper style={{ borderRadius: 0, width: '100%', minHeight: '50px', background: 'transparent' }}>
                <DrawerHeader style={{ marginLeft: 'auto' }}>
                    <>
                        {!open ? <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="end"
                            onClick={handleDrawerOpen}
                            sx={{ ...(open && { display: 'none' }) }}
                        >
                            <MenuIcon />
                        </IconButton>
                            :

                            <IconButton onClick={handleDrawerClose}
                            >
                                {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                            </IconButton>
                        }
                    </>
                </DrawerHeader>

            </Paper>
            <Drawer
                anchor={"right"}
                open={open}
                variant="temporary"
                onClose={handleDrawerClose}
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        border: '1px solid rgba(144, 202, 249, 0.46)',
                        borderRadius: '0px'
                    },
                    '& .MuiDrawer-root': {
                        position: 'unset'

                    },
                    '& .MuiPaper-root': {
                        position: 'right'

                    },
                }}
            >

                <Grid container spacing={4} style={{ paddingTop: '20px' }}>

                    <Grid item xs={12} sm={12} md={12} >


                        <MenuItem className={classes.barMenuItem} onClick={() => { navigate("/contact-us"); handleDrawerClose() }}>
                            <Typography className={classes.barMenuItemTypo} variant="h3" color="primary">
                                Contact Us</Typography>
                        </MenuItem>
                        <MenuItem className={classes.barMenuItem} onClick={() => { navigate("/about-us"); handleDrawerClose() }}>
                            <Typography className={classes.barMenuItemTypo} variant="h3" color="primary">
                                About Us</Typography>
                        </MenuItem>
                    </Grid>

                </Grid>

            </Drawer>
        </>

    );

}

export default SideBar
